export enum AppViewEnum {
  HYDROGEN = 0,
  CARBON_DIOXIDE = 1,
}
